import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    question: "How is PMS different from Trello?",
    answer:
      "PMS offers everything Trello does plus a built-in Secure Credentials Vault for storing API keys, FTP credentials, and secrets - something no other project management tool offers. We also provide real-time WebSocket updates, advanced role-based access control, and simpler pricing with no per-seat charges.",
  },
  {
    question: "Can I migrate from Trello or Asana?",
    answer:
      "Yes! We offer free migration assistance for teams switching from Trello, Asana, Monday.com, or any other project management tool. Our team will help you transfer your projects, boards, and team members seamlessly.",
  },
  {
    question: "How secure is the Credentials Vault?",
    answer:
      "Our Credentials Vault uses industry-standard encryption (AES-256) to protect your sensitive data. Role-based access control ensures only authorized team members can view credentials. We also maintain detailed audit logs of all access for compliance purposes.",
  },
  {
    question: 'What does "unlimited users" really mean?',
    answer:
      "Unlike competitors who charge per seat, our Pro plan includes truly unlimited team members for one flat monthly fee. Add 10 users or 100 - your price stays the same. No surprises, no hidden costs.",
  },
  {
    question: "Do you offer a free trial?",
    answer:
      "Yes! All paid plans come with a 14-day free trial with full access to all features. No credit card required to start.",
  },
  {
    question: "Can I use PMS for client projects?",
    answer:
      "PMS is perfect for agencies and freelancers managing client projects. You can invite clients as guests with limited permissions, store their credentials securely in the vault, and organize projects by categories.",
  },
];

const MarketingFAQ = ({ className = "" }) => {
  const [activeFaq, setActiveFaq] = useState(null);

  return (
    <section className={`curved-section shell-white section-animate ${className}`}>
      <div className="max-w-[95rem] mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-[2fr_3fr] gap-16 items-start">
        <div className="reveal">
          <span className="section-eyebrow">FAQ</span>
          <h2 className="mt-4 mb-6 stagger-1">
            Frequently asked <span className="text-navy">questions</span>
          </h2>
          <p className="text-lead stagger-2">Everything you need to know about PMS.</p>
        </div>
        <div className="space-y-4">
          {faqs.map((faq, idx) => {
            const open = activeFaq === idx;
            return (
              <div
                key={faq.question}
                className={`faq-item reveal stagger-${idx + 1}`}
              >
                <button
                  className="faq-button"
                  onClick={() => setActiveFaq(prev => (prev === idx ? null : idx))}
                >
                  <span>{faq.question}</span>
                  <ChevronDown className={`w-6 h-6 text-gray-400 transition-transform ${open ? "rotate-180" : ""}`} />
                </button>
                {open && (
                  <div className="faq-content">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MarketingFAQ;
